import React from 'react';

const EditIcon: React.FC<{ size?: number; color?: string }> = ({ size = 14, color = 'white' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5 3.5L16.5 6.5L7 16H4V13L13.5 3.5Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.5 5.5L14.5 8.5" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

export default EditIcon;

